import React from 'react'
import ReactModal from 'react-modal'
import styles from '@style/PopSlidein/index.scss'

const PopSlidein = ({ isOpen, close, children }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={close}
      closeTimeoutMS={300}
      className="Modal"
      overlayClassName="Overlay"
      ariaHideApp={false}
      id="popapp-popslidein"
    >
      <style jsx>{styles}</style>
      {children}
    </ReactModal>
  )
}

export default PopSlidein
